var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"EmployeeCreate"}},[_c('CustomerForm',{attrs:{"user":_vm.user,"submitForm":_vm.addRow,"hasEmployee":"true","hasReset":"true","buttonText":"Guardar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }